import React, { useEffect, useState, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { AreaChart, Area, XAxis, YAxis, Label, ResponsiveContainer, Tooltip } from 'recharts';
import Titulo from '../../Titulo';
import { useLogin } from '../../../contexts/LoginContext';
import { IAgrupamentoDia } from '../../../types/dashboard';
import { apiServer } from '../../../api';

interface IDadoGrafico {
    data: string;
    tamanho: number;
}

const criarDadoGrafico = (agrupamentoDia: IAgrupamentoDia) => {
    const diaFormatado = `${agrupamentoDia.dia}`.padStart(2, "0");
    const mesFormatado = `${agrupamentoDia.mes}`.padStart(2, "0");

    return {
        data: `${diaFormatado}/${mesFormatado}`,
        tamanho: agrupamentoDia.tamanho
    }
}

export default function GraficoArmazenamento() {
    const theme = useTheme();
    const [login] = useLogin();

    const [dadosGrafico, setDadosGrafico] = useState<IDadoGrafico[]>();

    const carregarDados = useCallback(() => {
        const clienteID = login.usuario?.usuarioCliente?.clienteID;
        if (!clienteID || !login.accessToken)
            return;

        apiServer<IAgrupamentoDia[]>()
            .get(`/dashboard/ultimos-30Dias/${clienteID}`, login.accessToken)
            .then((response) => {
                const agrupamentos = response.data;
                const dadosGrafico: IDadoGrafico[] = [];

                agrupamentos.forEach((dia) => {
                    dadosGrafico.push(criarDadoGrafico(dia));
                });

                setDadosGrafico(dadosGrafico);
            })
            .catch(() => {});
    }, [login.accessToken, login.usuario?.usuarioCliente?.clienteID]);

    useEffect(() => {
        carregarDados();
    }, [carregarDados]);

    return (
        <>
            <Titulo>Últimos 30 dias</Titulo>
            <ResponsiveContainer>
                <AreaChart
                    data={dadosGrafico}
                    margin={{
                        top: 16,
                        right: 16,
                        bottom: 0,
                        left: 24,
                    }}
                >
                    <defs>
                        <linearGradient id="colorTamanho" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.4}/>
                            <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <XAxis
                        dataKey="data"
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                        dy={8}
                    />
                    <YAxis
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                        dx={-8}
                    >
                        <Label
                            angle={270}
                            position="left"
                            style={{
                                textAnchor: 'middle',
                                fill: theme.palette.text.primary,
                                ...theme.typography.body1,
                            }}
                        >
                            Armaz. (GB)
                        </Label>
                    </YAxis>
                    <Tooltip 
                        contentStyle={{ 
                            backgroundColor: theme.palette.background.paper, 
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: '8px',
                            color: theme.palette.text.primary
                        }}
                        labelStyle={{ color: theme.palette.text.secondary }}
                    />
                    <Area
                        type="monotone"
                        dataKey="tamanho"
                        stroke={theme.palette.primary.main}
                        strokeWidth={2}
                        fillOpacity={1}
                        fill="url(#colorTamanho)"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </>
    );
}